<script setup lang="ts">
import { ConfigProvider } from 'reka-ui'
import { useLocale } from '../../composables/locale'

const { locale } = useLocale()
</script>

<template>
  <ConfigProvider :locale="locale.code">
    <slot />
  </ConfigProvider>
</template>
